<template>
  <el-dialog title="选择空间" width="842px" :visible.sync="showAlert" @open="getUserBody" @close="close">
    <div class="selectFirm">
      <div class="firmUserInfo">
        <div>
          <img :src="userInfo.avatar || avatar" :onerror="defaultAvatar" alt="">
          <div class="name">
            <span>账号名称：{{ userInfo.nickName }}</span>
            <p>手机号：{{ userInfo.phoneNum }}</p>
          </div>
          <el-button v-if="userInfo.isCreatePer != 1 && false" plain :loading="loading" @click="createSpace">创建空间</el-button>
        </div>
      </div>
      <div class="firm">
        <el-card shadow="hover" v-for="item in userInfo.list" :key="item.id" @click.native="selectBody(item)">
          <img :src="item.logo || avatar" :onerror="avatar" alt="">
          <div class="firmInfo">
            <div class="infoData">
              <div class="title">主体信息：</div>
              <span class="infoVal">
                <span class="name">{{ item.name }}</span>
                <span v-if="item.orgFlag == 1" class="personalSpace">个人空间</span>
                <span v-if="item.isOwnCreate == 1" class="weCompany">我的</span>
              </span>
            </div>
            <div>加入日期：{{ item.joinTime | formatDate('cn') }}</div>
          </div>
        </el-card>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { setToken } from "../../../tool/index"
import { createSpace, getUserBody, getBodyToToken } from "../../../api/accountManage"
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: null
    },
    sessionKey: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      showAlert: false,
      userInfo: {},
      defaultAvatar: require('../../../assets/img/avatar.png'),
      avatar: require('../../../assets/img/spaceAvatar.png')
    }
  },
  watch: {
    show(val) {
      this.showAlert = val
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false)
    },
    // 选择主体
    selectBody(item) {
      if (item.status === 1) {
        getBodyToToken({
          userId: this.userId,
          caihongId: item.caihongNo,
          employName: item.employName,
          sessionKey: this.sessionKey,
          orgCode: item.orgCode,
          employeeId: item.employeeId,
          platformType: 1,
          clientType: 1,
          orgFlag: item.orgFlag
        }).then(res => {
          if (res.data) {
            setToken("iyuanwu_token", res.data.accessToken)
            setToken("iyuanwu_refreshToken", res.data.refreshToken)
            setToken("iyuanwu_expiration", Date.parse(new Date()) + res.data.expiration * 1000)
            if (process.env.NODE_ENV === 'tests') {
              window.location.href = `${process.env.VUE_APP_API}/sso/api/sso/web/silent?clientType=SAAS&refreshToken=${res.data.refreshToken}&callBackUrl=${process.env.VUE_APP_INDEX_URL}`
            } else {
              this.$store.dispatch("goIndex")
            }
          }
        })
      } else {
        this.$alert(`您已被${item.name}停用，请选择其他主体`, '停用提示', {
          confirmButtonText: '确定',
          callback: () => { }
        });
      }
    },
    // 获取主体
    async getUserBody() {
      let { data } = await getUserBody({ userId: this.userId }).catch()
      this.userInfo = data
    },
    // 创建个人空间
    async createSpace() {
      this.loading = true
      await createSpace({ userId: this.userId });
      this.loading = false
      this.getUserBody()
      this.$message({
        type: 'success',
        message: '创建个人空间成功'
      });
    }
  }
}
</script>

<style lang="scss">
.selectFirm {
  .firmUserInfo {
    &>div {
      display: flex;
      align-items: center;

      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 16px;
      }

      .name {
        margin-right: 60px;

        span {
          color: $textColor;
        }

        p {
          margin-top: 16px;
          color: $gray;
        }
      }
    }
  }

  .firm {
    max-height: 455px;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow: auto;

    .el-card {
      margin-bottom: 24px;
      width: 385px;
      min-height: 206px;

      .el-card__body {
        padding: 16px 30px;

        img {
          max-width: 100%;
          max-height: 90px;
        }

        .firmInfo {
          .infoData {
            display: flex;

            .title {
              min-width: 70px;
            }

            .infoVal {
              display: flex;
              flex-wrap: wrap;

              .name {
                margin-right: 10px;
              }
            }
          }

          &>div {
            margin-top: 16px;
          }
        }
      }
    }
  }

  .bodyTag {
    padding: 1px 6px;
    border-radius: 2px;
    font-size: 12px;
    color: #fff;
  }

  .personalSpace {
    background: $primaryColor;
    @extend .bodyTag;
  }

  .weCompany {
    background: $green;
    @extend .bodyTag;
  }
}</style>